"use client";

import { displayValue } from "@/components/OtherBetsDropdown";
import { trendClass } from "./BetOkTrendUtils";

export default function BetOkThreeColSection({ title, items, width = "ods-50" }) {
  return (
    <div className={`ods-detail-item ${width}`}>
      <div className="odstb-title">
        <span>{title}</span>
        <span></span>
      </div>
      <div className="odstb-odds-list">
        {items.map((item, i) => (
          <div key={i}>
            <div className="title-odds">{item.label}</div>
            <div className={`odds ods-100 ods-white ${trendClass(item.trend)}`}>
              {displayValue(item.value)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
